import React from 'react'

import { useStoreActions, useStoreState } from 'store'

export default function MilitaryStatus() {
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const { updateDimensions } = useStoreActions(actions => actions.dimensions)
  const { veteranStatus } = useStoreState(state => state.dimensions.dimensions.user)

  const handleChange = () => {
    const value = veteranStatus === 'NoMilitaryService' ? 'RegularMilitary' : 'NoMilitaryService'
    updateDimensions({ user: { veteranStatus: value } })
    onInputTracking({ name: 'formermiltary', label: 'military/veteran', value })
  }

  return (
    <>
      <div className="form-element-container mb-0">
        <div className="FormControl float-right" data-switch="switch-container-va">
          <button
            data-testid="militaryStatus"
            className="switch small"
            data-switch="button"
            role="switch"
            aria-checked={veteranStatus !== 'NoMilitaryService'}
            aria-labelledby="switch-label-va"
            onClick={handleChange}
          >
            <span className="switch__label">
              <span className="visually-hidden">Off</span>
            </span>
            <span className="switch__label">
              <span className="visually-hidden">On</span>
            </span>
          </button>
        </div>
      </div>
    </>
  )
}
